import { omit } from '@/shared/utils/omit';
import { pick } from '@/shared/utils/pick';

import { BasisList, BasisType, CollectionName, PersonalIdentifierDetails } from '../../sj-orm';
import { QuestionType } from '../../sj-orm/models/form/question.dto';
import { Address, TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type SubstanceGeneralFormType = PersonalIdentifierGeneralFormType;

export const SubstanceGeneralSection: SubstanceGeneralFormType = {
  ...omit(commonGeneralFields, 'names', 'surnames', 'secondName', 'attachments'),
};

export type SubstanceDetailsDto = Omit<PersonalIdentifierDetails, 'createdAt' | 'updatedAt'> & {
  address?: Address;
  otherAddressInfo?: string;
  basis?: BasisType;
  supportingDocument?: string[];
  documentStartDate?: string;
};

type SubstanceDetailsHelp = {
  address: QuestionType.ADDRESS;
  otherAddressInfo: QuestionType.TEXT;
  basis: QuestionType.SELECT_FROM_LIST;
  supportingDocument: QuestionType.PICK_ARRAY_OF_DTO;
  documentStartDate: QuestionType.TEXT;
};

export type SubstanceDetailsFormType = PersonalIdentifierDetailsFormType &
  TDtoWrapper<SubstanceDetailsDto, SubstanceDetailsHelp>;

export const SubstanceDetailsSection: SubstanceDetailsFormType = {
  address: {
    type: QuestionType.ADDRESS,
    label: 'forms_personal_ids:common.inputs.address.label',
    tooltip: 'forms_personal_ids:common.inputs.address.label',
    value: undefined,
    order: -1,
  },
  otherAddressInfo: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:substance.inputs.otherAddressInfo.label',
    value: '',
    order: 1,
  },
  basis: {
    type: QuestionType.SELECT_FROM_LIST,
    label: 'forms_personal_ids:substance.inputs.basis.label',
    items: BasisList,
    order: 1,
  },
  supportingDocument: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    label: 'forms_personal_ids:substance.inputs.supportingDocument.label',
    items: CollectionName.PRIVATE_DOCUMENTS,
    order: 1,
  },
  ...pick(commonDetailsFields, 'idStatus', 'comments'),
};

export const SubstanceSections = [SubstanceGeneralSection, SubstanceDetailsSection];
